import { render, staticRenderFns } from "./SupplierAccountCard.vue?vue&type=template&id=44787230&scoped=true"
import script from "./SupplierAccountCard.vue?vue&type=script&lang=js"
export * from "./SupplierAccountCard.vue?vue&type=script&lang=js"
import style0 from "./SupplierAccountCard.vue?vue&type=style&index=0&id=44787230&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44787230",
  null
  
)

export default component.exports